import React, { Suspense } from "react";
import "./App.css";
import { Row } from "reactstrap";
import { Router, View } from "react-navi";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import { routes } from "./views/routes";
import { updateAttribute } from "./redux/actions/generalActions";
import Loading from "./views/loading";
import Header from "./views/layout/header";
import "react-toastify/dist/ReactToastify.css";
import ErrorBoundary from "./views/error";

function App(props) {
  let isAuthenticated = useSelector(
    state => state.generalReducer.isAuthenticated
  );
  const dispatch = useDispatch();
  try {
    if (!isAuthenticated || localStorage.getItem("jwtToken") !== null) {
      axios.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem(
        "jwtToken"
      )}`;
      dispatch(
        updateAttribute({
          isAuthenticated: true
        })
      );
    }
  } catch (err) {
    toast.error(`Error: ${err.message}`);
  }

  isAuthenticated = useSelector(state => state.generalReducer.isAuthenticated);
  return (
    <React.Fragment>
      <ErrorBoundary>
        <Router routes={routes} context={{ isAuthenticated }}>
          <Suspense fallback={<Loading />}>
            <View />
          </Suspense>
        </Router>
      </ErrorBoundary>
      <ToastContainer
        autoClose={2500}
        toastClassName="bg-black text-white"
        progressClassName="bg-white"
        position={toast.POSITION.BOTTOM_CENTER}
      />
    </React.Fragment>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx